import { colors } from '@packages/uiKit';
import styled from 'styled-components';

export const StyledClientTab = styled.div`
  border-top: 1px solid ${colors.gray2};
  padding-top: 13px;
`;
